import classNames from 'classnames'

type TefsirToggleProps = {
  isOpen: boolean
  onToggle: () => void
  /** Verses the tefsir covers, e.g. "1-5". Unknown until the tefsir is loaded. */
  verseRange?: string
}

/**
 * Collapsible header for a Diyanet tefsir section. Shared by the ayah page
 * (`GunlukOkuma/VerseCard`) and the Quran reader's meal popup so both look the same.
 */
const TefsirToggle = ({ isOpen, onToggle, verseRange }: TefsirToggleProps) => (
  <button
    type="button"
    onClick={onToggle}
    aria-expanded={isOpen}
    className="flex items-center justify-between w-full text-brand-secondary font-medium text-sm focus:outline-none"
  >
    <span>
      Tefsir (Diyanet)
      {verseRange && ` - Ayet: ${verseRange}`}
    </span>
    <svg
      className={classNames('w-5 h-5 transition-transform', { 'rotate-180': isOpen })}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  </button>
)

export default TefsirToggle
